import React__default from 'react';
import { MAPPING_SIZE } from '../../constants/index.es.js';
import { SizeContext } from '../../contexts/SizeContext.es.js';
import { Body } from '../Typography/index.es.js';
import { Shape } from '../Shape/index.es.js';
import { CommonStyles } from '../BaseProps/index.es.js';
import { themeColor } from '../../configs/Colors/index.es.js';
import { LazyImage } from '../LazyImage/LazyImage.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SelectionButton = (_a) => {
  var _b = _a, {
    isActive = false,
    size: customizeSize,
    prefix,
    suffix,
    content,
    isThumbnail = false,
    block,
    onClick,
    className
  } = _b, rest = __objRest(_b, [
    "isActive",
    "size",
    "prefix",
    "suffix",
    "content",
    "isThumbnail",
    "block",
    "onClick",
    "className"
  ]);
  var _a2, _b2;
  const size = React__default.useContext(SizeContext);
  const mergeSize = customizeSize || size || "m";
  const addonBefore = prefix ? /* @__PURE__ */ React__default.createElement(StyledShape, {
    height: MAPPING_SIZE[mergeSize]
  }, typeof prefix === "string" ? /* @__PURE__ */ React__default.createElement(Body, {
    level: 1,
    weight: "regular",
    className: "text",
    color: isActive ? "primary600" : "textSecondary"
  }, prefix) : React__default.cloneElement(prefix, {
    size: ((_a2 = prefix == null ? void 0 : prefix.props) == null ? void 0 : _a2.size) || 20,
    color: isActive ? themeColor.primary600 : themeColor.textSecondary
  })) : null;
  const addonAfter = suffix ? /* @__PURE__ */ React__default.createElement(StyledShape, {
    height: MAPPING_SIZE[mergeSize]
  }, typeof suffix === "string" ? /* @__PURE__ */ React__default.createElement(Body, {
    level: 1,
    weight: "regular",
    className: "text",
    color: isActive ? "primary600" : "textSecondary"
  }, suffix) : React__default.cloneElement(suffix, {
    size: ((_b2 = suffix == null ? void 0 : suffix.props) == null ? void 0 : _b2.size) || 16,
    color: isActive ? themeColor.primary600 : themeColor.textSecondary
  })) : null;
  return /* @__PURE__ */ React__default.createElement(Wrapper, __spreadValues({
    onClick: () => onClick && onClick(),
    size: mergeSize,
    isActive,
    isThumbnail,
    block: !!block,
    className
  }, rest), addonBefore, isThumbnail ? /* @__PURE__ */ React__default.createElement(LazyImage, {
    src: content || "",
    contain: true,
    height: MAPPING_SIZE[mergeSize] - 10,
    width: MAPPING_SIZE[mergeSize] - 10
  }) : /* @__PURE__ */ React__default.createElement(Body, {
    level: 1,
    color: isActive ? "primary600" : "textPrimary",
    weight: "regular",
    style: { textAlign: "center", flex: 1 },
    className: "text"
  }, content), addonAfter);
};
const Wrapper = styled.div(CommonStyles, ({ size, isActive, isThumbnail, block, theme }) => `
    display: flex;
    align-items: center;
    column-gap: 8px;
    border-radius: 4px;
    cursor: pointer;
    height: ${MAPPING_SIZE[size]}px;
    border: 1px solid ${isActive ? theme.colors.primary500 : "#E4E5F0"};
    &:hover {
      ${!isActive ? `border-color: ${theme.colors.border};` : ""}
    }
    padding: ${isThumbnail ? "4px" : "0 12px"};
    width: ${block ? "100%" : "max-content"};
    .text {
      margin-bottom: 3px;
    }
`);
const StyledShape = styled(Shape)`
  display: flex;
  align-items: center;
`;

export { SelectionButton };
